import React from "react";
import { motion } from "framer-motion";
import { MaskedLines, FadeUp } from "@/components/Reveal";
import { IMAGES } from "@/config";
import { easeLux, viewportOnce } from "@/lib/anim";

export default function About() {
    return (
        <section
            id="chi-siamo"
            className="relative scroll-mt-24 bg-[var(--fama-bg)] py-24 lg:py-32"
            data-testid="about-section"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
                {/* Images */}
                <div className="relative order-2 lg:order-1">
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={viewportOnce}
                        transition={{ duration: 1, ease: easeLux }}
                        className="relative aspect-[4/5] w-[82%] overflow-hidden rounded-[2px] ring-1 ring-[var(--fama-border)]"
                    >
                        <img
                            src={IMAGES.about}
                            alt="Salotto elegante di un appartamento gestito da FaMa Apartments"
                            className="h-full w-full object-cover"
                            loading="lazy"
                        />
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={viewportOnce}
                        transition={{ duration: 1, ease: easeLux, delay: 0.15 }}
                        className="absolute -bottom-8 right-0 aspect-square w-[46%] overflow-hidden rounded-[2px] border-4 border-[var(--fama-bg)] shadow-xl"
                    >
                        <img
                            src={IMAGES.aboutSecondary}
                            alt="Dettaglio di arredo curato"
                            className="h-full w-full object-cover"
                            loading="lazy"
                        />
                    </motion.div>
                </div>

                {/* Text */}
                <div className="order-1 lg:order-2">
                    <FadeUp>
                        <span className="font-body text-xs font-semibold uppercase tracking-[0.28em] text-[var(--fama-gold)]">
                            Chi siamo
                        </span>
                    </FadeUp>
                    <MaskedLines
                        as="h2"
                        lines={["Property manager a Roma,", "con la cura di un padrone", "di casa."]}
                        className="mt-5 font-serif-display text-4xl leading-[1.02] tracking-[-0.01em] text-[var(--fama-ink)] sm:text-5xl lg:text-6xl"
                    />
                    <FadeUp delay={0.1}>
                        <p className="mt-7 max-w-xl font-body text-base leading-relaxed text-[var(--fama-ink-soft)] sm:text-lg">
                            FaMa Apartments nasce a Roma per gestire strutture
                            ricettive per conto dei proprietari, con un approccio
                            full-service e artigianale. Ci occupiamo di ogni
                            dettaglio, dall'avvio burocratico all'accoglienza
                            degli ospiti, con la stessa attenzione che
                            avremmo per casa nostra.
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.18}>
                        <p className="mt-4 max-w-xl font-body text-base leading-relaxed text-[var(--fama-ink-soft)]">
                            Che tu abbia un solo appartamento o un portfolio
                            immobiliare, trasformiamo la tua proprietà in
                            un'esperienza ospitale e in un investimento
                            ottimizzato.
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.26}>
                        <blockquote className="mt-9 border-l-2 border-[var(--fama-gold)] pl-6 font-serif-display text-2xl italic leading-snug text-[var(--fama-ink)] sm:text-3xl">
                            “Zero pensieri per te, massima resa per il tuo
                            immobile.”
                        </blockquote>
                    </FadeUp>
                </div>
            </div>
        </section>
    );
}
